import styled from "styled-components";

import { ToggleSwitch } from "components/atoms/Toggle/Toggle.styled";
import { colourScheme } from "utils/styling/colours";
import { Label as TypoLabel } from "utils/styling/typography.styled";

export const ControlsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    gap: 1rem;
    align-items: center;
    width: 100%;
    padding: 1rem 0rem;
`;

export const ToggleContainer = styled.div`
    display: flex;
    gap: 0.5rem;
`;

export const Icon = styled.div`
    display: inline-block;
    cursor: pointer;
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
`;

export const HeartCheckbox = styled.input.attrs({ type: "checkbox" })`
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;
`;

export const IconWrapper = styled.div`
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease-in-out;

    & img {
        width: 100%;
        height: 100%;
    }

    &:hover {
        transform: scale(1.1);
    }
`;

export const ReactContainer = styled.div`
    display: flex;
    gap: 0.5rem;
`;

export const Label = styled(TypoLabel)`
    display: inline-flex;
    align-items: center;
    font-size: 1rem;
`;

export const PopoverItem = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: ${colourScheme.white};
    cursor: pointer;
    transition: transform 0.1s ease-in-out;

    & > span {
        white-space: nowrap;
    }

    &:hover {
        transform: scale(1.03);
    }
`;

export const SmallToggleSwitch = styled(ToggleSwitch)`
    width: 2rem;
    height: 1.2rem;

    .slider:before {
        height: 1rem;
        width: 1rem;
        left: 0.1rem;
        bottom: 0.1rem;
    }

    input:checked + .slider:before {
        transform: translateX(1rem);
    }
`;
